module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"inventories":"Inventuren","number":"Nummer","tenant":"Mandant","warehouse":"Lager","dateOfCounting":"Zählungsdatum","createdAt":"Erstellt am","createdBy":"Erstellt von","type":"Art"},"en":{"inventories":"Inventories","number":"Number","tenant":"Tenant","warehouse":"Warehouse","dateOfCounting":"Date of counting","createdAt":"Created at","createdBy":"Created by","type":"Type"}}')
  delete Component.options._Ctor
}
